




























import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Transcription from '../../store/modules/transcription';
import store from '@/store/store';

const trscModule = getModule(Transcription, store);
@Component
export default class StartTranscriptionDialog extends Vue {
  @Prop(Boolean)
  value!: boolean;
  syncMode = false

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit('input', value);
  }

  start() {
    this.show = false;
    trscModule.startEditing({syncMode: this.syncMode});
    this.$router.push({ name: 'transcription.edit' });
    this.$emit('start')
  }
}
